import {
  Button,
  Checkbox,
  FlexBox,
  JoonUIColor,
  Modal,
  ModalHeader,
  SessionBookingLinkType,
  SPACING,
  TextButton,
  TextInput,
  Typography,
} from "@joonapp/web-shared"
import { useState } from "react"

import { useSessionBookingModalStore } from "./hooks/useSessionBookingModalStore"
import { useSessionMakeUpVerificationModalStore } from "./hooks/useSessionMakeUpVerificationModalStore"
import { useUpdateSessionBookingMutation } from "../../../networking/sessions/mutations"
import { useSessionBookingsQuery } from "../../../networking/sessions/queries"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../../util/analytics"
import { localStorageItems } from "../../../util/storage"

const SessionMakeupVerificationModal = () => {
  const { isOpen, onClose, sessionBookingId, makeupSessionBookingLink } =
    useSessionMakeUpVerificationModalStore()
  const [reason, setReason] = useState("")
  const [hasVerifiedWithAdmin, setHasVerifiedWithAdmin] = useState(false)

  const { onOpen: openSessionBookingModal } = useSessionBookingModalStore()
  const updateSessionBookingMutation = useUpdateSessionBookingMutation()

  const { data: sessionBookings } = useSessionBookingsQuery()
  const sessionBooking = sessionBookings?.find(
    (booking) => booking.id === sessionBookingId
  )

  const handleClose = () => {
    onClose()
  }

  const verifyMakeupAndOpenBookingModal = () => {
    // Update the session booking with reason and if verified
    if (!sessionBookingId || !makeupSessionBookingLink) return
    updateSessionBookingMutation.mutate({
      sessionBookingId,
      reason,
      hasVerifiedWithAdmin,
    })
    // Close the modal
    onClose()
    // open the make up schedule modal
    openSessionBookingModal(
      makeupSessionBookingLink,
      SessionBookingLinkType.MAKEUP_BOOKING
    )
    trackAnalyticEvent(ANALYTIC_EVENTS.MAKEUP_COACH_SESSION, {
      reason,
      auto_scheduled: sessionBooking?.auto_scheduled,
    })
    localStorage.setItem(localStorageItems.needsToRefreshBookings, "true")
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      animate
      style={{ width: "min(500px, 100vw)" }}
    >
      <ModalHeader
        title="Schedule make-up sessions"
        onClose={onClose}
        showBorderBottom
      />
      <FlexBox
        style={{ padding: SPACING.space6, paddingTop: SPACING.space4 }}
        direction="column"
        gap={SPACING.space6}
      >
        <Typography variant="body">
          Only do this if no-show/late cancellation{" "}
          <Typography variant="bodyBold">
            was due to an understandable unforeseen circumstances at your
            discretion. You need to verify with Brad before moving forward.
          </Typography>
        </Typography>
        <FlexBox direction="column" gap={SPACING.space2}>
          <Typography variant="bodySmall">
            Reason for make-up (required)
          </Typography>
          <TextInput
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason"
            name="reason"
            fullWidth
          />
        </FlexBox>
        <button
          style={{
            borderRadius: SPACING.space2,
            padding: SPACING.space2,
            display: "flex",
            flexDirection: "row",
            gap: SPACING.space1,
            alignItems: "center",
            width: "100%",
            background: JoonUIColor.background.lightBlue,
          }}
          onClick={() => setHasVerifiedWithAdmin(!hasVerifiedWithAdmin)}
        >
          <Checkbox
            selected={hasVerifiedWithAdmin}
            onChange={() => {}}
            name="reason"
            hideBorder
          />
          <Typography variant="body">I have verified with Brad</Typography>
        </button>
        <FlexBox
          direction="row"
          gap={SPACING.space4}
          align="center"
          justify="flex-end"
        >
          <TextButton onClick={handleClose}>
            <Typography variant="body">Cancel</Typography>
          </TextButton>
          <Button
            text="View Schedule"
            disabled={!hasVerifiedWithAdmin || !reason}
            onClick={verifyMakeupAndOpenBookingModal}
          />
        </FlexBox>
      </FlexBox>
    </Modal>
  )
}

export default SessionMakeupVerificationModal
